import HotelInfoData from "../../components/hotel/datamanagement/HotelInfoData";

export default function HotelInfoPage() {
  return <HotelInfoData />;
}

